import { navigation } from "@src/navigation";
import { PatientEncounterPage } from "@src/pages/PatientEncounter";
import { Navigate, useParams } from "react-router-dom";

export function meta() {
  return [
    { title: "Patient Encounter" },
    { name: "description", content: "Patient encounter page" },
  ];
}

export default function PatientEncounter() {
  const params = useParams();

  const patientId = params.patientId;
  const encounterId = params.encounterId;

  if (!patientId || !encounterId) {
    return <Navigate to={navigation.dashboardNotFound()} />;
  }

  return (
    <PatientEncounterPage patientId={patientId} encounterId={encounterId} />
  );
}
